import React from 'react';
import { ArrowRight, Truck, Factory, Package, FileCheck2 } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';

const ICONS = [Truck, Factory, Package, FileCheck2];

export default function SystemOverviewSection() {
  const { t } = useLanguage();

  return (
    <section className="bg-white border-b border-ct-line py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="text-[11px] font-bold uppercase tracking-widest text-ct-brand mb-3">
            {t.overview.subtitle}
          </p>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-black text-ct-ink tracking-tight"
            style={{ fontFamily: 'Chivo, sans-serif' }}
          >
            {t.overview.title}
          </h2>
        </div>

        <div className="relative grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {/* Desktop connector line */}
          <div
            aria-hidden="true"
            className="hidden lg:block absolute top-[72px] left-[12.5%] right-[12.5%] h-px bg-gradient-to-r from-transparent via-ct-line-strong to-transparent"
          />

          {t.overview.steps.map((step, i) => {
            const Icon = ICONS[i] || Truck;
            return (
              <div
                key={i}
                className="ct-card-lift relative bg-white border border-ct-line rounded-ct-card p-6 text-center flex flex-col items-center ct-shadow-sm"
                data-testid={`overview-step-${i}`}
              >
                <div className="relative mb-4">
                  <div className="w-14 h-14 bg-ct-ink text-white flex items-center justify-center rounded-ct-card">
                    <Icon className="w-6 h-6" strokeWidth={1.75} />
                  </div>
                  <span
                    className="absolute -top-1.5 -right-1.5 bg-ct-brand text-white text-[10px] font-black px-1.5 py-0.5 font-mono tabular-nums rounded-ct-chip"
                    style={{ fontFamily: 'IBM Plex Mono, monospace' }}
                  >
                    {String(i + 1).padStart(2, '0')}
                  </span>
                </div>

                <h3
                  className="font-black text-ct-ink uppercase tracking-wide text-sm mb-2"
                  style={{ fontFamily: 'Chivo, sans-serif' }}
                >
                  {step.label}
                </h3>
                <p className="text-[13px] text-ct-ink-3 leading-relaxed">{step.desc}</p>

                {i < t.overview.steps.length - 1 && (
                  <div
                    aria-hidden="true"
                    className="hidden lg:flex absolute right-0 top-[72px] translate-x-1/2 -translate-y-1/2 z-10 w-6 h-6 bg-white border border-ct-line rounded-full items-center justify-center ct-shadow-sm"
                  >
                    <ArrowRight className="w-3 h-3 text-ct-brand" strokeWidth={2.5} />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
